// extracted by mini-css-extract-plugin
export default {"titleContainer":"ntCVr","title":"oDqZ8","subtitle":"XLv06","color":"uir4y","link":"ECpV5"};